<div class="header">
  <div class="right">
    <div class="ano">
      <div class="ano-label">Ano</div>
      <select
        class="ano-select"
        [value]="anoSelecionado"
        (change)="setAno($any($event).target.value)"
      >
        @for (a of anos; track a) {
          <option [value]="a">{{ a }}</option>
        }
      </select>
    </div>

    <div class="modes" aria-label="Tipos de visão">
      <button
        type="button"
        class="mode"
        [class.active]="viewMode==='GRAFICOS'"
        (click)="setMode('GRAFICOS')"
        aria-label="Gráficos de custo"
        matTooltip="Gráficos de custo"
        matTooltipPosition="above"
      >
        <img class="mode-icon" src="assets/grafico-custos.svg" alt="Gráficos" />
      </button>

      <button
        type="button"
        class="mode"
        [class.active]="viewMode==='RANKING'"
        (click)="setMode('RANKING')"
        aria-label="Ranking de custos"
        matTooltip="Ranking de custos"
        matTooltipPosition="above"
      >
        <img class="mode-icon" src="assets/ranking-custos.svg" alt="Ranking" />
      </button>
    </div>
  </div>
</div>
